/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Bell_Back_In_StockInputs */

const he_notifications_bell_back_in_stock = /** @type {(inputs: Notifications_Bell_Back_In_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`רוצים לקבל התראה כשהמוצר חוזר למלאי?`)
};

const en_notifications_bell_back_in_stock = /** @type {(inputs: Notifications_Bell_Back_In_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want to get notified when back in stock?`)
};

/**
* | output |
* | --- |
* | "Want to get notified when back in stock?" |
*
* @param {Notifications_Bell_Back_In_StockInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_bell_back_in_stock = /** @type {((inputs?: Notifications_Bell_Back_In_StockInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Bell_Back_In_StockInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_bell_back_in_stock(inputs)
	return en_notifications_bell_back_in_stock(inputs)
});